const errorCode = {
  '-8940004': '用户token过期,请重新登录',
  '-8940002': '',
};

// 我不会跳过枚举值
const jumpListReason = [
  { codeType: 7, test: '题目太难' },
  { codeType: 2, test: '没学会这个知识点' },
  { codeType: 1, test: '题目看不懂' },
  { codeType: 4, test: '没有思路' },
  { codeType: 5, test: '有超纲内容，做不出来' },
];

// 换题的枚举值
const changeTopicReason = [
  { codeType: 56, test: '题目太难' },
  { codeType: 51, test: '没学会这个知识点' },
  { codeType: 50, test: '题目看不懂' },
  { codeType: 53, test: '没有思路' },
  { codeType: 54, test: '有超纲内容，做不出来' },
];

// 报告页上直接跳过枚举值
const jumpReportListReason = [
  { codeType: 7, test: '题目太难' },
  { codeType: 2, test: '没学会这个知识点' },
  { codeType: 1, test: '题目看不懂' },
  { codeType: 4, test: '没有思路' },
  { codeType: 5, test: '有超纲内容，做不出来' },
  { codeType: 8, test: '单词不认识' },
  { codeType: 9, test: '其他原因' },
  { codeType: 10, test: '直接跳过' },

  { codeType: 50, test: '题目看不懂' },
  { codeType: 51, test: '没学会这个知识点' },
  { codeType: 53, test: '没有思路' },
  { codeType: 54, test: '有超纲内容，做不出来' },
  { codeType: 55, test: '头都做大了' },
  { codeType: 56, test: '题目太难' },
  { codeType: 57, test: '单词不认识' },
  { codeType: 58, test: '其他原因' },
  { codeType: 59, test: '切换难题' },
];

export {
  errorCode,
  changeTopicReason,
  jumpListReason,
  jumpReportListReason,
};
